import useImageStyle from "./useImageStyle";
import { getBackgroundPatternClass } from "../utils/backgroundPatternUtils";

/**
 * Custom hook to extract and compute background image and pattern styles.
 * @param {Object} background - The background object from the page.
 * @returns {Object} - Computed background properties.
 */
const useBackground = (background = {}) => {
  const { show_image, background_image, background_image_url, background_pattern, image_style } =
    background || {};

  // Compute image style classes and inline styles
  // Support both legacy shape:
  //   { background_image: { image, image_style } }
  // and current backend shape:
  //   { background_image_url, image_style }
  const imageStyleSource =
    background_image ||
    (image_style ? { image_style } : null);
  const { styleClasses: imageStyleClasses, inlineStyles: imageInlineStyles } =
    useImageStyle(imageStyleSource);

  // URL of the background image, if available and show_image is true
  const bgImageUrl =
    show_image
      ? (background_image?.image || background_image_url || null)
      : null;

  // Compute pattern classes and styles
  const {
    colorClass: bgPatternClass = "",
    colorStyle: bgPatternStyle = {},
    jsPatternLayer: bgPatternJsLayer = null,
  } = getBackgroundPatternClass(background_pattern);

  return {
    bgImageUrl,
    imageStyleClasses,
    imageInlineStyles,
    bgPatternClass,
    bgPatternStyle,
    bgPatternJsLayer,
  };
};

export default useBackground;
